import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M3.5 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M5 2.25a.625.625 0 0 1-.625-.625v-1a.625.625 0 0 1 1.25 0v1A.625.625 0 0 1 5 2.25m1.945.805a.623.623 0 0 1 0-.883l.707-.708a.625.625 0 0 1 .884.884l-.708.707a.623.623 0 0 1-.883 0M7.75 5a.625.625 0 0 1 .625-.625h1a.625.625 0 0 1 0 1.25h-1A.625.625 0 0 1 7.75 5m-.805 1.945a.623.623 0 0 1 .883 0l.708.707a.625.625 0 0 1-.884.884l-.707-.708a.623.623 0 0 1 0-.883M5 7.75a.625.625 0 0 1 .625.625v1a.625.625 0 0 1-1.25 0v-1A.625.625 0 0 1 5 7.75m-1.945-.805a.623.623 0 0 1 0 .883l-.707.708a.625.625 0 0 1-.884-.884l.708-.707a.623.623 0 0 1 .883 0M2.25 5a.625.625 0 0 1-.625.625h-1a.625.625 0 0 1 0-1.25h1A.625.625 0 0 1 2.25 5m.805-1.945a.623.623 0 0 1-.883 0l-.708-.707a.625.625 0 0 1 .884-.884l.707.708a.623.623 0 0 1 0 .883"
    }, null, -1)
  ]));
}
const interfaceLightingBrightness = { render };
export {
  interfaceLightingBrightness as default,
  render
};
//# sourceMappingURL=interface-lighting-brightness.svg.js.map
